import React from 'react';
import { Dialog } from 'primereact/dialog';

export type CancelScheduleDialogProps = {
  visible: boolean;
  certId: string;
  certificateName: string;
  insuredDatabaseId: string;
  onHide: () => void;
  onSuccess: () => void;
};

const CancelScheduleDialog: React.FC<CancelScheduleDialogProps> = ({
  visible,
  certId,
  certificateName,
  insuredDatabaseId,
  onHide,
  onSuccess,
}) => {
  const [cancelling, setCancelling] = React.useState(false);
  const [cancelError, setCancelError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (visible) setCancelError(null);
  }, [visible]);

  const handleConfirm = async () => {
    setCancelling(true);
    setCancelError(null);
    try {
      const ncToken = localStorage.getItem('NCToken') || '';
      const authToken = localStorage.getItem('igtoken') || '';
      const res = await fetch(`${process.env.REACT_APP_COIPortal_Url}/api/igigcoi/cancel-scheduled-datetime`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          NCToken: ncToken,
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ historicalCertificateHolderId: certId, insuredDatabaseId, certificateName }),
      });
      if (!res.ok) {
        const txt = await res.text().catch(() => '');
        throw new Error(txt || `Request failed [${res.status}]`);
      }
      onSuccess();
    } catch (err: any) {
      setCancelError(err.message || 'Failed to cancel schedule. Please try again.');
    } finally {
      setCancelling(false);
    }
  };

  return (
    <Dialog
      visible={visible}
      onHide={() => { if (!cancelling) onHide(); }}
      header={null}
      footer={null}
      closable={!cancelling}
      className="archiveConfirmDialog"
      style={{ width: 420 }}
      modal
      draggable={false}
      resizable={false}
    >
      <div className="archiveDialog__iconWrap">
        <i className="pi pi-ban archiveDialog__icon" style={{ color: '#dc2626' }} />
      </div>
      <div className="archiveDialog__title">Cancel Scheduled Send</div>
      <div className="archiveDialog__message">
        Are you sure you want to cancel the scheduled send for <strong>"{certificateName}"</strong>?
        <br />It will no longer be sent automatically.
      </div>
      {cancelError && (
        <div style={{ color: '#dc2626', fontSize: 12, marginTop: 10, textAlign: 'center' }}>{cancelError}</div>
      )}
      <div className="archiveDialog__footer" style={{ marginTop: 20, justifyContent: 'flex-end' }}>
        <button
          type="button"
          className="p-button p-button-text archiveDialog__cancelBtn"
          onClick={onHide}
          disabled={cancelling}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontWeight: 500, fontFamily: 'inherit', color: '#6b7280', padding: '8px 16px', borderRadius: 6 }}
        >
          Keep
        </button>
        <button
          type="button"
          onClick={handleConfirm}
          disabled={cancelling}
          style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 20px', fontWeight: 600, fontSize: 12, fontFamily: 'inherit', cursor: cancelling ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 6, opacity: cancelling ? 0.7 : 1 }}
        >
          <i className={`pi ${cancelling ? 'pi-spin pi-spinner' : 'pi-ban'}`} style={{ fontSize: 12 }} />
          {cancelling ? 'Cancelling...' : 'Cancel Schedule'}
        </button>
      </div>
    </Dialog>
  );
};

export default CancelScheduleDialog;
